import { render, staticRenderFns } from "./overlay-drawer-artworks-card.vue?vue&type=template&id=faf9facc"
import script from "./overlay-drawer-artworks-card.vue?vue&type=script&lang=js"
export * from "./overlay-drawer-artworks-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports